import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Button,
  Grid,
  Checkbox,
  ButtonBase,
} from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import CareTeamCategory from "./care_team_category";
import AccessLocalStorage from "../../services/localStorage";
import { getApiUrl } from "../../services/api_service";
import { dashboardText, icon34, lightcolor, pcolor, rcolor, whitecolor } from "../../style2";
import { light } from "@mui/material/styles/createPalette";

// const useStyles = makeStyles((theme) => ({
//   searchBox: {
//     border: "0.5px solid #FF767E",
//     borderRadius: 7,
//     margin: "auto",
//     height: 40.46,
//     boxShadow: "none",
//   },
//   button: {
//     fontFamily: "Lato",
//     fontStyle: "normal",
//     fontWeight: "normal",
//     fontSize: 14,
//     color: rcolor,
//     textTransform: "unset",
//     "&:hover": {
//       background: whitecolor,
//     },
//   },
//   dropdownfilter: {
//     border: "0.5px solid #FF767E",
//     borderTopLeftRadius: 10,
//     borderBottomLeftRadius: 10,
//     borderTopRightRadius: 0,
//     borderBottomRightRadius: 0,
//     borderRight: 0,
//     borderColor: rcolor,
//     boxSizing: "border-box",
//     width: 200,
//     fontFamily: "Lato",
//     fontStyle: "normal",
//     fontWeight: "normal",
//     fontSize: 14,
//     color: "#001244",
//     textTransform: "unset",
//     height: 40.46,
//   }, mainGrid: {
//     border: "1px solid #fff",
//     backgroundColor: "#F6F6F6",
//     borderRadius: "9px",
//     padding: "20px"
//   },
//   dropdowniconborder: {
//     border: "0.5px solid #FF767E",
//     minHeight: 40.46,
//     minWidth: 40,
//     borderTopRightRadius: 10,
//     borderBottomRightRadius: 10,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   dropdownicon: {
//     color: rcolor,
//   },
//   title: {
//     fontWeight: "bold",
//     fontSize: 16,
//     color: "#001244",
//     paddingLeft: 20,
//   },
//   endIcon: {
//     position: "absolute",
//     right: 25,
//   },
//   dropdownmenutext: {
//     fontSize: 14,
//     color: "#001244",
//   },
//   paddingTopLeft: {
//     paddingLeft: 20,
//     paddingTop: 30,
//   },
//   paddingTopRight: {
//     paddingRight: 20,
//     paddingTop: 30,
//   },
//   paddingRight: {
//     paddingRight: 20,
//   },
//   paddingLeft: {
//     paddingLeft: 20,
//   },
// }));

// const searchBox = {
//   border: "0.5px solid "+ rcolor,
//   borderRadius: 7,
//   margin: "auto",
//   height: 40.46,
//   boxShadow: "none",
// };

// const button = {
//   fontFamily: "Lato",
//   fontStyle: "normal",
//   fontWeight: "normal",
//   fontSize: 14,
//   color: rcolor,
//   textTransform: "unset",
//   "&:hover": {
//     background: whitecolor,
//   },
// };

const dropdownfilter = {
  border: "0.5px solid " + rcolor,
  borderTopLeftRadius: 10,
  borderBottomLeftRadius: 10,
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  borderRight: 0,
  borderColor: rcolor,
  boxSizing: "border-box",
  width: 200,
  fontFamily: "Lato",
  fontStyle: "normal",
  fontWeight: "normal",
  fontSize: 14,
  color: "#001244",
  textTransform: "unset",
  height: 40.46,
};

const mainGrid = {
  border: `1px solid ${whitecolor}`,
  backgroundColor: lightcolor,
  borderRadius: "9px",
  padding: "20px",
};

const dropdowniconborder = {
  border: "0.5px solid " + rcolor,
  minHeight: 40.46,
  minWidth: 40,
  borderTopRightRadius: 10,
  borderBottomRightRadius: 10,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const dropdownicon = {
  color: rcolor,
};

// const title = {
//   fontWeight: "bold",
//   fontSize: 16,
//   color: "#001244",
//   paddingLeft: 20,
// };

// const endIcon = {
//   position: "absolute",
//   right: 25,
// };

const dropdownmenutext = {
  fontSize: 14,
  color: "#001244",
};

// const paddingTopLeft = {
//   paddingLeft: 20,
//   paddingTop: 30,
// };

// const paddingTopRight = {
//   paddingRight: 20,
//   paddingTop: 30,
// };

// const paddingRight = {
//   paddingRight: 20,
// };

// const paddingLeft = {
//   paddingLeft: 20,
// };

function Care_Teams() {

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState();
  const [showHealthCareTeam, setShowHealthCareTeam] = useState(true);
  const [showSocialCareTeam, setShowSocialCareTeam] = useState(true);
  const [showEducationTeam, setShowEducationTeam] = useState(true);
  const [showOtherAgencies, setShowOtherAgencies] = useState(true);

  const recordButtonPosition = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const ls = new AccessLocalStorage();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }

    fetch(`${getApiUrl()}${process.env.REACT_APP_GET_CARE_TEAM}/${ls.getCurrentPatientId()}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        //console.log(data);
        setData(data);
      })
      .catch((err) => {
        setError(err.message || "An error occurred.");
        setData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  let closeMenu = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const setShow = (e) => {
    if (e.target.value === "1") {
      showHealthCareTeam
        ? setShowHealthCareTeam(false)
        : setShowHealthCareTeam(true);
    }
    if (e.target.value === "2") {
      showSocialCareTeam
        ? setShowSocialCareTeam(false)
        : setShowSocialCareTeam(true);
    }
    if (e.target.value === "3") {
      showEducationTeam
        ? setShowEducationTeam(false)
        : setShowEducationTeam(true);
    }
    if (e.target.value === "4") {
      showOtherAgencies
        ? setShowOtherAgencies(false)
        : setShowOtherAgencies(true);
    }
  };

  const [search, setSearch] = useState("");
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setTimeout(() => { setMounted(true) }, 300);
  }, []);
  if (!mounted) return null;
  return (
    <>
      <Grid container xs={12}>
        <Grid item xs={6}>
          <Box display="flex" alignItems="center" sx={{ ...dashboardText, color: pcolor }}>
            <Box component="img" src="assets/primary-care.png" sx={icon34}></Box>
            <Box mr={1} />
            Care Team
          </Box>
        </Grid>

        <Grid item xs={6} sm alignContent='center'>
          <Grid container justifyContent='flex-end'  >
            <ButtonBase onClick={recordButtonPosition} sx={{ backgroundColor: whitecolor, borderRadius: "10px", border: "0px" }}>
              <Button sx={{ ...dropdownfilter, color: rcolor }}>All Professionals</Button>
              <Box sx={dropdowniconborder}>
                <KeyboardArrowDownIcon sx={dropdownicon} />
              </Box>
            </ButtonBase>
            <Menu anchorEl={anchorEl} open={menuOpen} onClose={closeMenu}
              PaperProps={{
                style: {
                  border: "0.5px solid #FF767E",
                  borderRadius: "7px 7px 7px 7px",
                  borderTop: 0,
                  boxShadow: "none",
                  minWidth: 240,
                  display: 'flex !important',
                  flexDirection: 'column'
                }
              }}
            >
              <MenuItem value='1' onClick={(e) => setShow(e)}>
                <Checkbox
                  sx={{ color: "#ACB9FF" }}
                  checked={showHealthCareTeam}
                  value='1'
                  onClick={(e) => setShow(e)}
                />
                <Typography sx={dropdownmenutext}>
                  Health Care Team
                </Typography>
              </MenuItem>
              <MenuItem value='2' onClick={(e) => setShow(e)}>
                <Checkbox
                  sx={{ color: "#ACB9FF" }}
                  checked={showSocialCareTeam}
                  value='2'
                  onClick={(e) => setShow(e)}
                />
                <Typography sx={dropdownmenutext}>
                  Social Care Team
                </Typography>
              </MenuItem>
              <MenuItem value='3' onClick={(e) => setShow(e)}>
                <Checkbox
                  sx={{ color: "#ACB9FF" }}
                  checked={showEducationTeam}
                  value='3'
                  onClick={(e) => setShow(e)}
                />
                <Typography sx={dropdownmenutext}>
                  Education Team
                </Typography>
              </MenuItem>
              <MenuItem value='4' onClick={(e) => setShow(e)}>
                <Checkbox
                  sx={{ color: "#ACB9FF" }}
                  checked={showOtherAgencies}
                  value='4'
                  onClick={(e) => setShow(e)}
                />
                <Typography sx={dropdownmenutext}>
                  Other Agencies
                </Typography>
              </MenuItem>
            </Menu>
            <Box m={1} />
          </Grid>

        </Grid>
      </Grid>

      <Box m={2} />
      <Box sx={mainGrid}>
        {/* <Grid container>
         <Grid item xs={12} sm={4} sx={paddingTopLeft}>
          <SearchBox onChange={(newValue) => setSearch(newValue)} />
        </Grid>
      </Grid> */}
        {showHealthCareTeam ? (
          <CareTeamCategory title={"Health Care Team"} search={search} professionalType={1} list={data} />
        ) : null}
        <Box mt={3} />
        {showSocialCareTeam ? (
          <CareTeamCategory title={"Social Care Team"} search={search} professionalType={2} list={data} />
        ) : null}
        <Box mt={3} />
        {showEducationTeam ? (
          <CareTeamCategory title={"Education Team"} search={search} professionalType={3} list={data} />
        ) : null}
        <Box mt={3} />
        {showOtherAgencies ? (
          <CareTeamCategory title={"Other Agencies"} search={search} professionalType={4} list={data} />
        ) : null}
        <Box mt={3} />
      </Box></>
  );
}

export default Care_Teams;
